import { ServicesContainer } from '@/services';
import { ExternalCampaignEvent } from '@/services/analytics/events/';
import { AnalyticsEventType, Marketing } from '@/services/analytics/platforms/adobe-analytics/models';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { AdobeHomePageLoadEvent } from './adobe-home-page-load';

export class AdobeExternalCampaignEvent extends AdobeHomePageLoadEvent {
  event = AnalyticsEventType.PageLoaded;
  marketing: Marketing = {};

  constructor(event: ExternalCampaignEvent, store: Store<AppState>, services: ServicesContainer) {
    super(event, store, services);
    const query = event.query;

    this.marketing = {
      respondentID: `${query.lyid ?? ''}`,
      trackingCode: `${query.utm_campaign ?? ''}|${query.utm_source ?? ''}|${query.utm_medium ?? ''}|${query.utm_content ?? ''}|${query.utm_term ?? ''}`
    }
  }
}
